import {AfterViewInit, Component, TemplateRef, ViewChild} from '@angular/core';
import {View} from "src/app/common/view";
import {Handler} from "src/app/common/handler";
import {AppContext} from "../../../../app-context";
import {map, Observable, of} from "rxjs";
import {
    ConsumptionTax,
    FacetFilter,
    FacetResult,
    FacetValueResult,
    GetMyConsumptionTaxesNew
} from "@flowmaps-com/flowmaps-typescriptmodels";
import {filterByTermArray, uuid} from "../../../../common/utils";
import {sendFacetsQuery} from "../../../../common/app-common-utils";
import {AddTaxComponent} from "../add-tax/add-tax.component";
import {FacetUtils, GetFacetValues} from "../../../../common/facets/facet-utils";
import {SentenceCasePipe} from "../../../../common/sentence-case.pipe";
import {HandleQuery} from "../../../../common/handle-query";

@Component({
  selector: 'app-taxes-overview',
  templateUrl: './taxes-overview.component.html',
  styleUrls: ['./taxes-overview.component.scss']
})
@Handler()
export class TaxesOverviewComponent extends View implements AfterViewInit {
  appContext = AppContext;
  facetUtils = FacetUtils;

  term: string;
  query: Observable<ConsumptionTax[]>;
  data: ConsumptionTax[] = [];
  facets: Observable<FacetResult>;
  facetFilters: FacetFilter[];
  hiddenFacets: string[] = ["intermediaryId"];
  defaultFacetFilters: FacetFilter[] = [{
    facetName: "taxInfo/country",
    values: ["NL"]
  }];

  @ViewChild("filtersInModal") filtersTemplate: TemplateRef<any>;

  ngAfterViewInit() {
    this.executeQuery();
  }

  executeQuery = () => {
    const query: GetMyConsumptionTaxesNew = this.getDataQuery();
    const intermediaryId = AppContext?.userProfile?.intermediaryId;
    this.query = this.subscribeTo("getConsumptionTaxes", query)
        .pipe(map((o: ConsumptionTax[]) => o
            .filter(t => !intermediaryId || t.intermediaryId === intermediaryId)
            .filter(filterByTermArray([this.term]))));
    this.facets = this.getFacets(query);
  }

  private getFacets(query: GetMyConsumptionTaxesNew) {
    return sendFacetsQuery("com.flowmaps.api.organisation.GetMyConsumptionTaxesNew", query, {caching: false});
  }

  private getDataQuery() {
    return <GetMyConsumptionTaxesNew>{facetFilters: this.facetFilters};
  }

  trackByForRecord = (index: number, record: ConsumptionTax) => record.taxId;

  addTax = () => this.openModal(AddTaxComponent, {
    taxId: uuid(),
    taxInfo: {},
    taxPeriods: []
  });

  openFiltersInModal = () => this.openModal(this.filtersTemplate, null);

  facetValueFormatter = (name: string): (value: string) => string => {
    switch (name) {
      case "taxInfo/country": return (v: string) => v.toUpperCase();
      default: return (v: string) => SentenceCasePipe.format(v);
    }
  }

  @HandleQuery("getFacetValues", { global: true })
  getFacetValues(query: GetFacetValues): Observable<FacetValueResult[]> {
    if (Object.keys(this.facetFilters).length) {
      const dataQuery = this.getDataQuery();
      return FacetUtils.getFacetValues(dataQuery, this.getFacets, query.facetName);
    }
    return of(query.allFacets.find(f => f.name === query.facetName).values);
  }
}
